import axios from "axios"
import baseURL from "../configs/api"

export const getAdditionalCharges = (tenantId: string) => {
    return getFetch("additionalCharge", tenantId);
}

export const getAdditionalCharge = (primaryKey: string, tenantId: string) => {
    return getFetch(`additionalCharge/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}